
import { Action, Reducer } from 'redux';
import { initialIpc1752aData, Ipc1752AXmlData, SubstanceCategory, Ipc1752AExportState, Product, BusinessInfo } from '../../Models/XmlExport/XmlExportDataModel';
import { ToxnotServiceClient } from '../../ToxnotServiceClient';
import { AppThunkAction, AppThunkActionAsync } from './../../';


const XmlExportSetData = "SET_XMLEXPORT_DATA";
interface SetXmlExportData {
    type: typeof XmlExportSetData;
    value: Partial<Ipc1752AExportState>
}

const initialState: Ipc1752AExportState = {
    inventoryId: null,
    ipc1752aData: initialIpc1752aData(),
    selectedProduct: null,
    exportClassA: false,
    exportClassC: false,
    exportClassD: false,
    dataLoaded: false,
    showAlert: false,
    hightlightMissingRequiredFields: false,
    isProductionServer: true
}

type KnownAction = SetXmlExportData ;

export const actionCreators = {
    setXmlExportState: (value: Partial<Ipc1752AExportState>): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        const state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }
        dispatch({
            type: XmlExportSetData,
            value: value
        })
        if (state.dataLoaded && state.inventoryId !== null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    setBusinessData: (value: Partial<BusinessInfo>): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        const state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }
        dispatch({
            type: XmlExportSetData,
            value: {
                ipc1752aData: {
                    ...state.ipc1752aData,
                    businessInfo: {
                        ...state.ipc1752aData.businessInfo,
                        ...value
                    }
                }
            }
        })
        if (state.dataLoaded && state.inventoryId != null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    getIpc1752aData: (inventoryId: string, refresh: boolean): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        const state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        const serviceClient = new ToxnotServiceClient();

        const apiResult = await serviceClient.getIpc1752aData(inventoryId, refresh);
        const appServices = await serviceClient.getAppServices();

        if (!apiResult.success || apiResult.data === null || !appServices.success || appServices.data === null) {
            return;
        }

        dispatch({
            type: XmlExportSetData,
            value: {
                inventoryId: inventoryId,
                selectedProduct: apiResult.data.products.length > 0 ? apiResult.data.products[0] : null,
                dataLoaded: true,
                ipc1752aData: {
                    ...state.ipc1752aData,
                    ...apiResult.data,
                    businessInfo: {
                        ...apiResult.data.businessInfo,
                        mode: "Distribute"
                    }
                },
                isProductionServer: appServices.data.config.isProductionServer
            }
        });

    },
    setOverThresholdValue: (productIndex: number, sclIndex: number, scIndex: number, overThreshold: boolean): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        let state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        const value: Partial<Ipc1752AExportState> = {
            ipc1752aData: {
                ...state.ipc1752aData,
                products: [
                    ...state.ipc1752aData.products.map((v, i) => {
                        if (i === productIndex) {
                            v.materialInfo.substanceCategoryLists[sclIndex].substanceCategories[scIndex].overThreshold = overThreshold;
                        }
                        return v;
                    })
                ]
            }
        }

        dispatch({
            type: XmlExportSetData,
            value: value
        })

        if (state.dataLoaded && state.inventoryId != null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    removeSubstanceCategory: (productIndex: number, sclIndex: number, scIndex: number): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        let state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        const value: Partial<Ipc1752AExportState> = {
            ipc1752aData: {
                ...state.ipc1752aData,
                products: [
                    ...state.ipc1752aData.products.map((v, i) => {
                        if (i === productIndex) {
                            v.materialInfo.substanceCategoryLists[sclIndex].substanceCategories.splice(scIndex, 1);
                        }
                        return v;
                    })
                ]
            }
        }

        dispatch({
            type: XmlExportSetData,
            value: value
        })

        if (state.dataLoaded && state.inventoryId != null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    setQueryListResponse: (listId: string, queryId: string,response: boolean|null): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        let state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        for (let queryList of state.ipc1752aData.products[0].materialInfo.queryList) {
            for (let query of queryList.queries) {
                if (query.identity === queryId && listId === queryList.identity) {
                    if (response === null) {
                        query.response = null;
                    } else {
                        query.response = response;
                    }
                }
            }
        }

        dispatch({
            type: XmlExportSetData,
            value: {
                ipc1752aData: {
                    ...state.ipc1752aData,
                }
            }
        })

        if (state.dataLoaded && state.inventoryId != null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    removeHomogenousMaterial: (productName: string, productNumber: string, productPlant: string, hmIndex: number, sclIndex: number, scIndex: number): AppThunkActionAsync<KnownAction> =>  async (dispatch, getState) => {
        let state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        const value: Partial<Ipc1752AExportState> = {
            ipc1752aData: {
                ...state.ipc1752aData,
                products: [
                    ...state.ipc1752aData.products.map((v, i) => {
                        return deleteSubstance(v, productName, productNumber, productPlant, hmIndex, sclIndex, scIndex);
                    })
                ]
            }
        }

        dispatch({
            type: XmlExportSetData,
            value: value
        })

        if (state.dataLoaded && state.inventoryId != null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    addRohsExemptionToSubstance: (identity: string, description: string, productName: string, productNumber: string, productPlant: string, hmIndex: number, sclIndex: number, scIndex: number): AppThunkActionAsync<KnownAction> => async (dispatch, getState) => {
        let state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        const value: Partial<Ipc1752AExportState> = {
            ipc1752aData: {
                ...state.ipc1752aData,
                products: [
                    ...state.ipc1752aData.products.map((v, i) => {
                        return addRohsExemptionToSubstance(identity,description,v, productName, productNumber, productPlant, hmIndex, sclIndex, scIndex);
                    })
                ]
            }
        }

        dispatch({
            type: XmlExportSetData,
            value: value
        })

        if (state.dataLoaded && state.inventoryId != null) {
            const serviceClient = new ToxnotServiceClient();
            await serviceClient.setIpc1752aData(state.ipc1752aData, state.inventoryId);
        }
    },
    generateXML: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        let state = getState().ipc1752aExportState;
        if (!state) {
            return;
        }

        if (state.inventoryId === null) {
            throw new Error("inventory id not set");
        }

        if (allRequiredFieldsFilled(state)) {
            dispatch({
                type: XmlExportSetData,
                value: {
                    showAlert: true,
                    hightlightMissingRequiredFields: true
                }
            });
            return;
        }

        const downloadExport = () => {
            const link = "/Api/ExportIpc1752aXML?inventoryId=" + encodeURIComponent(state!.inventoryId!) + "&exportClassA=" + encodeURIComponent(state!.exportClassA) + "&exportClassC=" + encodeURIComponent(state!.exportClassC) + "&exportClassD=" + encodeURIComponent(state!.exportClassD);
            window.location.href = link;
        }

        if (!state.exportClassA && !state.exportClassC && !state.exportClassD) {
            if (confirm(getState().appServices?.localizeString("You haven't selected any of the 3 data export classes, so your export will be empty. Click ok to proceed."))) {
                downloadExport();
            }
        }
        else {
            downloadExport();
        }
    }
}

function allRequiredFieldsFilled(state: Ipc1752AExportState) {
    let requiredFieldsEmpty = false;

    const x = state.ipc1752aData.products.map((v, i) => v.materialInfo.substanceCategoryLists).reduce((a, b) => a.concat(b),[]).map((sc, i1) => sc.substanceCategories).reduce((a, b) => a.concat(b),[]);

    if (x.find((v, i) => v.overThreshold === null) && state.exportClassC) requiredFieldsEmpty = true;

    const businessInfo = state.ipc1752aData.businessInfo;

    let supplierInfoFieldsEmpty = false;
    if (!(businessInfo.authorizedRepresentiative && businessInfo.representativeEmail && businessInfo.representativePhone && businessInfo.companyName && businessInfo.responseDate
        && businessInfo.supplierContact.contactEmail && businessInfo.supplierContact.contactName && businessInfo.supplierContact.contactPhone)) {
        supplierInfoFieldsEmpty = true;
    }
    let requestInfoFieldsEmpty = false;
    if (!(businessInfo.requestDate && businessInfo.requestCompany && businessInfo.requestorContact.contactEmail && businessInfo.requestorContact.contactName && businessInfo.requestorContact.contactPhone)) {
        requestInfoFieldsEmpty = true;
    }

    const fieldMissing = requiredFieldsEmpty || supplierInfoFieldsEmpty || (businessInfo.mode === "Request/Reply" && requestInfoFieldsEmpty);

    return !fieldMissing;
}

export const reducer: Reducer<Ipc1752AExportState> = (state: Ipc1752AExportState | undefined, action: Action): Ipc1752AExportState => {
    if (state === undefined) {
        return initialState;
    }
    let incomingAction;
    switch (action.type) {
        case XmlExportSetData:
            incomingAction = action as SetXmlExportData;
            const requiredFieldsFilled = allRequiredFieldsFilled(state);
            const x = {
                ...state,
                ...incomingAction.value,
                showAlert: !requiredFieldsFilled,
                highlightMissingRequiredFields: !requiredFieldsFilled
            }
            return x;
    }
    return state;
}

function deleteSubstance(product: Product,  productName: string, productNumber: string, productPlant: string, hmIndex: number ,sclIndex: number, scIndex: number) : Product{

    if (product.productId.itemName === productName && product.productId.itemNumber === productNumber && product.productId.manufacturingSite === productPlant) {
        product.materialInfo.homogenousMaterialsList[hmIndex].substanceCategoryLists[sclIndex].substanceCategories.splice(scIndex, 1);
        return product;
    } else if (product.subproduct.length > 0) {
        product.subproduct.forEach((v, i) => v = deleteSubstance(v, productName, productNumber, productPlant, hmIndex, sclIndex, scIndex));
        return product;
    } else {
        return product;
    }

}

function addRohsExemptionToSubstance(identity: string, description: string ,product: Product, productName: string, productNumber: string, productPlant: string, hmIndex: number, sclIndex: number, scIndex: number): Product {

    if (product.productId.itemName === productName && product.productId.itemNumber === productNumber && product.productId.manufacturingSite === productPlant) {
        if (description === "") {

            product.materialInfo.homogenousMaterialsList[hmIndex].substanceCategoryLists[sclIndex].substanceCategories[scIndex].rohsExemption = null;

        } else {
            product.materialInfo.homogenousMaterialsList[hmIndex].substanceCategoryLists[sclIndex].substanceCategories[scIndex].rohsExemption = {
                exemptions: [],
                authority: "EL2011/534/EU",
                identity: "IPC"
            }
            product.materialInfo.homogenousMaterialsList[hmIndex].substanceCategoryLists[sclIndex].substanceCategories[scIndex].rohsExemption?.exemptions.push({ identity: identity, description: description });
        }
        return product;
    } else if (product.subproduct.length > 0) {
        product.subproduct.forEach((v, i) => v = addRohsExemptionToSubstance(identity, description, v, productName, productNumber, productPlant, hmIndex, sclIndex, scIndex));
        return product;
    } else {
        return product;
    }

}
